import React, { useState } from 'react'
import { Card, Col, Container, Row, Spinner, Table, InputGroup , Image, Form} from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { FaBars, FaFacebookMessenger, FaFile, FaMobile, FaMobileAlt, FaSearch, FaStar, FaVoicemail } from "react-icons/fa";
import { RootState } from '../../../../store/Index';
import TripCard from '../../components/trip_card/Index';
import NotFound from '../../../notfound/Indesx';
import { get } from '../../../../config/services/api/ApiServices';
import { CommonStyles } from '../../../../common/styles/CommonStyles';
import { TripBaseCard } from '../../parkingUser/gate_in_pending/Index';
import { FetchUserData } from '../../../../common/functions/CommonFunctions';
import moment from 'moment';


const PodDoneForTransporter = (props: any) => {

    const user = useSelector((state: any) => state.user);
    const auth = useAppSelector((state: RootState) => state.auth);
    const [searchText, setSearchText] = useState("")
    const [trips, setTrips] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const payModeData = [
        { label: 'Today', value: '1' },
        { label: 'Yesterday', value: '2' },
        { label: 'Day before Yesterday', value: '3' }
    ];
    const [selectedDate, setSelectedDate] = React.useState<any>(payModeData[0])

    const handleDateSelection = (item: any) => {
        setSelectedDate(item);
      };

    React.useEffect(() => {
        getAllTrips()
    }, [searchText, selectedDate])

    async function getAllTrips() {
        setLoading(true);
        const path = 'Trips/GetTrips';
        let date = selectedDate.value == '1' ? moment() : (selectedDate.value == '2' ? moment().subtract(1, 'days') : moment().subtract(2, 'days'))

        const body = {
            "UserID": user.userID,
            "TransporterID": user.transporterID,
            "UserType": user.userType,
            "Type": 'in-transit',
            "Page": 1,
            "PODFromDate": moment(date, 'DD MMM YYYY').format('YYYY-MM-DDTHH:mm:ss'),
            "PODToDate": moment(date, 'DD MMM YYYY').format('YYYY-MM-DDTHH:mm:ss'),
            "IsPodGenerated": true,
            "search": searchText,
        }
        const header = {
            "Content-Type": 'application/json',
            // "UserType" : user.userType,
            "Authorization": auth.jwToken
        }
        var response = await get(path, body, header);

        setLoading(false);
        if (response.succeeded) {
            setTrips((response.data.allTrips));
        }
    }

    return (
        <Container fluid>

            <Row style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                <Col xxl={6} xl={6} md={6} sm={6} xs={6} className="p-0 m-0 justify-content-end">
                    <InputGroup className="w-100">
                        <Form.Control
                            placeholder="Search here ..."
                            aria-label="search"
                            aria-describedby="basic-addon1"
                            className="w-50"
                            size="sm"
                            onChange={(e: any) => setSearchText(e.target.value)}
                        />
                        <InputGroup.Text id="basic-addon1"><FaSearch /></InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col xxl={6} xl={6} md={6} sm={6} xs={6} className="p-0 m-0 justify-content-end">
                    <div>
                        {payModeData.map((item)=>(
                            <button key={item.value} className='btn ms-2'
                            style={{ borderRadius:12, backgroundColor: selectedDate.value === item.value ? "green": "white", borderColor : selectedDate.value === item.value ? "none": "green", borderWidth : selectedDate.value === item.value ? 0 : 1}}
                            onClick={()=>{
                                handleDateSelection(item)
                            }}>
                                <p style={{color : selectedDate.value === item.value ? "white": "green",fontSize :14, margin : 0 }} className='text-center'>{item.label}</p>
                            </button>
                        ))}
                    </div>
                </Col>
            </Row>

            {loading ? (
                <div style={CommonStyles.loader} className='d-flex justify-content-center align-items-center'>
                    <Spinner animation="border" role="status">
                    </Spinner>
                </div>
            ) : (
                <Row>
                    {trips.length > 0 ? (
                        <>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Shipment No</th>
                                        <th>Vehicle No</th>
                                        <th>Trip Date</th>
                                        <th>Unloading Points</th>
                                        <th>Unloading Area</th>
                                        <th>Material Type (Quantity)</th>
                                        <th>Delivery Date</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody className='contentArea'>
                                    {trips.map((item: any, index:any) => <TripCard data={item} key={index}/>)}
                                </tbody>
                            </Table>
                        </>
                    ) : <NotFound />}
                </Row>
            )}

        </Container>
    )
}

export default PodDoneForTransporter